import React from 'react';
import { connect } from 'react-redux';

import { withRouter } from 'react-router-dom';
import { compose, withState, withHandlers, branch, lifecycle, renderComponent } from 'recompose';
import PropTypes from 'prop-types';

import { authUserRequest, getTokenFromCookies } from '../redux/reducers/login';

import {
  getUserProgramsFullRequest,
  selectUserPrograms,
  selectUserModule,
  selectUserContent,
  selectUserVersion,
} from '../redux/reducers/userProgramsFull';
import {
  learnerVersionsRequest,
  addPathToSaveVersion,
  resetLearnerVersion,
  overwriteVersionRequest,
  saveVersionRequest
} from '../redux/reducers/savedVersions';

import { selectedContent, getAllThinkTools, getAllThinkToolsAndJournals, selectedVersion, getSelectedThinktool } from '../redux/selectors';

import Spinner from '../Components/Spinner';
import authHOC from '../Components/AuthHOC';
import LearnerThinkToolView from './Components/LearnerThinkToolView';
import { versionStatusRequest, setVersionStatus } from '../redux/reducers/versionStatus';
import { STATUSES } from '../constants';
import { addComponentStatusRequest, saveStatus } from '../redux/reducers/addComponentStatus';
import { xapiRequest } from '../redux/reducers/xapi';
import { contentItemRequest } from '../redux/reducers/contentList';
import { dropdownsRequest } from '../redux/reducers/dropdowns';
import { showSaveModal } from '../redux/reducers/view';

const LearnerThinkTool = ({ pathForIFrame, onReceiveMessage , onClose}) => (
  <LearnerThinkToolView pathForIFrame={pathForIFrame} onReceiveMessage={onReceiveMessage} onClose={onClose} />
);

LearnerThinkTool.propTypes = {
  pathForIFrame: PropTypes.string,
  onReceiveMessage: PropTypes.func,
  onClose: PropTypes.func,
};

const mapStateToProps = state => ({
  loginReducer: state.loginReducer,
  userProgramsFull: state.userProgramsFullReducer,
  selectedContent: selectedContent(state),
  getAllThinkTools: getAllThinkTools(state),
  getAllThinkToolsAndJournals: getAllThinkToolsAndJournals(state),
  savedVersions: state.savedVersionsReducer,
  view: state.viewReducer,
  selectedVersion: selectedVersion(state),
  getSelectedThinktool: getSelectedThinktool(state),
  statusUpdate: state.addComponentStatus
  
});

const mapDispatchToProps = dispatch => ({
  getToken: token => dispatch(getTokenFromCookies(token)),
  authUser: () => dispatch(authUserRequest()),
  getContentItem: () => dispatch(contentItemRequest()),
  selectUserPrograms: programId => dispatch(selectUserPrograms(programId)),
  selectUserModule: moduleId => dispatch(selectUserModule(moduleId)),
  selectUserContent: contentId => dispatch(selectUserContent(contentId)),
  selectUserVersion: versionId => dispatch(selectUserVersion(versionId)),
  learnerVersionsRequest: () => dispatch(learnerVersionsRequest()),
  addPathToSaveVersion: path => dispatch(addPathToSaveVersion(path)),
  resetLearnerVersion: () => dispatch(resetLearnerVersion()),
  overwriteVersionRequest: () => dispatch(overwriteVersionRequest()),
  saveVersionRequest: () => dispatch(saveVersionRequest()),
  versionStatusRequest:(string) => dispatch(versionStatusRequest(string)),
  setVersionStatus:(string) => dispatch(setVersionStatus(string)),
  saveStatus:(string) => dispatch(saveStatus(string)),
  showSaveModal:(string) => dispatch(showSaveModal(string)),
  xapiRequest: xapiType => dispatch(xapiRequest(xapiType)),
  dropdownsRequest: () => dispatch(dropdownsRequest()),
  addComponentStatusRequest: () => dispatch(addComponentStatusRequest()),
});

export default compose(
   
  withState('pathForIFrame', 'getPathForIFrame', null),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withHandlers({
    onClose: props => event => {
      var thinktool = props.userProgramsFull.item
      props.history.push('/content/'+thinktool.program_id+'/'+thinktool.module_id+'/')
    },
    onReceiveMessage: props => event => {
      
    try {
      var obj = JSON.parse(event.data)

      var thinktool = props.userProgramsFull.item

      if(obj.action=='BACK'){
        props.xapiRequest({ xapiType: `Closed`});
        if (event.data) {
        
          if (typeof event.data === 'string') {
        
            props.addPathToSaveVersion(JSON.parse(event.data).path);
          } else {
          
            props.addPathToSaveVersion(event.data.path);
          }

        }
        if(thinktool.type=='Journal'){
          var versionPath=props.pathForIFrame;
      
          var versionArray = String(versionPath).split('versionid=');
    
          if(versionArray.length>1){
            
            props.selectUserVersion(parseInt(versionArray[1]))
            
            props.overwriteVersionRequest();
          }else{
            
            props.saveVersionRequest();
          }
          if(props.selectedContent.status!='completed'){
            props.saveStatus(STATUSES.inProgress.value);
          }
          props.history.push('/content/'+thinktool.program_id+'/'+thinktool.module_id+'/')
          props.showSaveModal(true)
        }else{
            props.saveStatus(STATUSES.inProgress.value);
            props.addComponentStatusRequest();
            props.history.push('/versions/'+props.userProgramsFull.selectedProgramId+'/'+props.userProgramsFull.selectedModuleId+'/'+props.userProgramsFull.selectedContentId)
            props.setVersionStatus('draft')
        }
        props.getContentItem();
      
      }
      if(obj.action=='COMPLETED'){
        
        if (event.data) {
        
          if (typeof event.data === 'string') {
        
            props.addPathToSaveVersion(JSON.parse(event.data).path);
          } else {
          
            props.addPathToSaveVersion(event.data.path);
          }

        }
        if(thinktool.type=='Journal'){
          props.xapiRequest({ xapiType: `Completed`});
          var versionPath=props.pathForIFrame;
      
          var versionArray = String(versionPath).split('versionid=');
    
          if(versionArray.length>1){
            
            props.selectUserVersion(parseInt(versionArray[1]))
            
            props.overwriteVersionRequest();

            
         
          }else{
            
            props.setVersionStatus('completed')
            props.saveVersionRequest();
          }
          if(props.selectedContent.status!='completed'){
            
            saveStatus(STATUSES.completed.value);
            props.setVersionStatus('completed')
            props.saveVersionRequest();
          }
          props.history.push('/content/'+thinktool.program_id+'/'+thinktool.module_id+'/')
          props.showSaveModal(true)
        }else{
          props.xapiRequest({ xapiType: `Completed`});
          props.setVersionStatus('completed')
            props.history.push('/versions/'+props.userProgramsFull.selectedProgramId+'/'+props.userProgramsFull.selectedModuleId+'/'+props.userProgramsFull.selectedContentId)
        }
      
      }
    } catch (error) {}
   
     
    },
  }),
  authHOC,
  lifecycle({
    componentWillMount() {
      const {
        userProgramsFull,
        match: { params },
        selectUserPrograms,
        selectUserModule,
        selectUserContent,
        selectUserVersion,
        selectedContent,
        getPathForIFrame,
        savedVersions,
        pathForIFrame,
        getContentItem,
        learnerVersionsRequest,
        getAllThinkTools,
        getAllThinkToolsAndJournals,
        loginReducer,
      } = this.props;
      if (
        savedVersions.isFetched === false &&
        loginReducer.user !== null &&
        loginReducer.user.userId
      ) {
        getContentItem()
        learnerVersionsRequest();
      }
      
      if (userProgramsFull.selectedContentId === null) {
        selectUserPrograms(parseFloat(params.programId));
        //selectUserModule(parseFloat(params.moduleId));
        selectUserContent(parseFloat(params.contentId));
        if (params.versionId) {
          selectUserVersion(parseFloat(params.versionId));
        }
      }
      
      if (
        !userProgramsFull.selectedUserVersion &&
        Array.isArray(savedVersions.learnerVersions) &&
        savedVersions.learnerVersions.length
      ) {
         getPathForIFrame(this.props.userProgramsFull.item.path);
      }
      
      if (userProgramsFull.selectedUserVersion === null) {
        if (getAllThinkToolsAndJournals && !pathForIFrame) {
          var content = this.props.userProgramsFull.item
          var p = content.path

          var split = String(p).split('version')

          if(content.type=='Journal'){
            
            getPathForIFrame(
              p+'&thinktool=false'
            );
          }else{
            
            getPathForIFrame(
              split[0]+'&thinktool=true'
            );
          }
        }
      }else{
        
        // var p = getAllThinkToolsAndJournals.find(
        //   content => content.contentId === userProgramsFull.selectedContentId,
        // ).path

        var split = String(p).split('version')
        getPathForIFrame(
          this.props.selectedVersion.path+'&thinktool=true'
        );
      }

      window.history.pushState(null, null, window.location.href);
      window.onpopstate = () => window.history.go(1);
    },
    componentWillReceiveProps(nextProps) {
      const {
        userProgramsFull,
        loginReducer,
        getUserProgramsFullRequest,
        savedVersions,
        getPathForIFrame,
        learnerVersionsRequest,
        selectedContent,
        pathForIFrame,
        getAllThinkTools,
        getAllThinkToolsAndJournals
      } = nextProps;

      // if (
      //   savedVersions.isFetched === false &&
      //   savedVersions.fetching === false &&
      //   loginReducer.user !== null &&
      //   loginReducer.user.userId
      // ) {
      //   learnerVersionsRequest();
      // }
      // if (loginReducer.user !== null && userProgramsFull.programs === null) {
      //   if (!userProgramsFull.isFetched && !userProgramsFull.fetching) {
      //     getUserProgramsFullRequest();
      //   }
      // }
      if(this.props.statusUpdate.isFetched==false && nextProps.statusUpdate.isFetched==true){
        this.props.getContentItem()
      }
      if (userProgramsFull.selectedUserVersion !== null && savedVersions.learnerVersions) {
        if (selectedContent) {
          if (selectedContent.type!='ThinkTool') {
           // selectedContent.path
          }
        }
      }
      if (userProgramsFull.selectedUserVersion === null) {
        if (getAllThinkToolsAndJournals && !pathForIFrame) {
          
          getPathForIFrame(
            this.props.userProgramsFull.item.path,
          );
        }
      }
    },
  }),
 
)(LearnerThinkTool);
